import React from 'react';
import { Typography } from "@mui/material";

// TODO delete this 
export const Loading = () => {
    return <Typography variant="h6">Authentication in progress...</Typography>
}